import { createSlice } from "@reduxjs/toolkit";
import { initialPopupState } from "./popup.state";
import { getPopup } from "./popup.thunk";

export const popupSlice = createSlice({
  name: "popup",
  initialState: initialPopupState,
  reducers: {
    clearPopup: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPopup.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getPopup.fulfilled, (state, action) => {
        state.status = "success";
        const raw = action.payload.data;
        state.data = Array.isArray(raw) || !raw ? null : raw;
      })
      .addCase(getPopup.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload ?? "Popup yüklenemedi.";
      });
  },
});

export const { clearPopup } = popupSlice.actions;
export default popupSlice.reducer;